import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    receiveOrder: {
        //TableProductList
        offset: 0,
        limit: 10,
        //TableCapacityProduct
        start_date: null,
        end_date: null,
    },
    waitingSend: {
        offset: 0,
        limit: 10,
    },
    processDelivery: {
        startDate: null,
        endDate: null,
        wording: '',
        offset: 0,
        limit: 10,
    }, 
    completeOrder: {
        offset: 0,
        limit: 10,
    },
    cancelOrder: {
        offset: 0,
        limit: 10,
    }
}

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setReceiveOrderOffset: (state, action) => {
            state.receiveOrder.offset = action.payload;
        },
        setReceiveOrderLimit: (state, action) => {
            state.receiveOrder.limit = action.payload;
        },
        setReceiveOrderStartDate: (state, action) => {
            state.receiveOrder.start_date = action.payload;
        },
        setReceiveOrderEndDate: (state, action) => {
            state.receiveOrder.end_date = action.payload;
        },
        setWaitingSendOffset: (state, action) => {
            state.waitingSend.offset = action.payload;
        },
        setWaitingSendLimit: (state, action) => {
            state.waitingSend.limit = action.payload;
        },
        setProcessDeliveryStartDate: (state, action) => {
            state.processDelivery.startDate = action.payload;
        },
        setProcessDeliveryEndDate: (state, action) => {
            state.processDelivery.endDate = action.payload;
        },
        setProcessDeliveryWording: (state, action) => {
            state.processDelivery.wording = action.payload;
        },
        setProcessDeliveryOffset: (state, action) => {
            state.processDelivery.offset = action.payload;
        },
        setProcessDeliveryLimit: (state, action) => {
            state.processDelivery.limit = action.payload;
        },
        setCompleteOrderOffset: (state, action) => {
            state.completeOrder.offset = action.payload;
        },
        setCompleteOrderLimit: (state, action) => {
            state.completeOrder.limit = action.payload;
        },
        setCancelOrderOffset: (state, action) => {
            state.cancelOrder.offset = action.payload;
        },
        setCancelOrderLimit: (state, action) => {
            state.cancelOrder.limit = action.payload;
        },
    },
});

export const {
    setReceiveOrderOffset,
    setReceiveOrderLimit,
    setReceiveOrderStartDate,
    setReceiveOrderEndDate,
    setWaitingSendOffset,
    setWaitingSendLimit,
    setProcessDeliveryStartDate,
    setProcessDeliveryEndDate,
    setProcessDeliveryWording,
    setProcessDeliveryOffset,
    setProcessDeliveryLimit,
    setCompleteOrderOffset,
    setCompleteOrderLimit,
    setCancelOrderOffset,
    setCancelOrderLimit,
} = orderSlice.actions;

export default orderSlice.reducer;